export enum SectorStyleProps {
  RED = 'red'
}
